module.exports = __webpack_public_path__ + "media/images/close-c0e35a55feb0ee58efde94bb214e1219.svg";